export const TOP_FILTERS = [
  { param: 'top_pnl_24h', value: true, text: 'Топ PnL 24ч', fullText: 'Сортировка ставок от большего PnL к меньшему за 24 часа' },
  { param: 'top_trades_24h', value: true, text: 'Топ Ставки 24ч', fullText: 'Сортировка ставок от большей суммы ставки к меньшей за 24 часа' },
  { param: 'bet_value', value: 10000, text: 'Ставки >$10K 24ч', fullText: 'Фильтрация ставок больше $10,000' },
  { param: 'insider', value: true, text: 'Инсайдеры', fullText: 'Кошельки, похожие на инсайдеров (редкие и крупные ставки с активными позициями)' },
];

export const INSIDER_FILTER_PARAMS = ['insider'];

//Имена пользовательских оверрайдов порогов инсайдер-фильтра. Single source для store/URL/API.
export const INSIDER_PARAM_NAMES = [
  'max_unique_markets',
  'min_max_bet',
  'min_op_value',
  'fresh_wallet_window_days',
];

export const CATEGORIES = [
  { value: 'politics', text: 'Политика' },
  { value: 'crypto', text: 'Крипта' },
  { value: 'pop-culture', text: 'Культура' },
  { value: 'finance', text: 'Финансы' },
  { value: 'sports', text: 'Спорт' },
];

//Инсайдер-режим: sports и pop-culture исключаем, чтобы матчиться с polysights-логикой на бэке.
export const INSIDER_EXCLUDED_CATEGORY_SLUGS = ['sports', 'pop-culture'];
export const INSIDER_CATEGORIES = CATEGORIES.filter(
  (c) => !INSIDER_EXCLUDED_CATEGORY_SLUGS.includes(c.value),
);

export const HEADER_ITEMS = [
  { text: 'Время', icon: null, align: 'start' },
  { text: 'Событие', icon: null, align: 'start' },
  { text: 'Кошелек', icon: null, align: 'start' },
  { text: 'Ставка', icon: null, align: 'start' },
  { text: 'Цена', icon: null, align: 'start' },
  { text: null, icon: 'arrow', align: 'center' },
  { text: 'Сейчас', icon: null, align: 'end' },
  { text: 'PnL', icon: null, align: 'end' },
];

export const CATEGORIES_STORAGE_KEY = 'polymarket_categories';

export const BOOKMARKS_COUNT_KEY = 'polymarket_bookmarks_count';

export const DEFAULT_CATEGORIES = ['politics', 'crypto', 'pop-culture', 'finance'];

export const PROVIDE_SCREEN_WIDTH_KEY = 'screen_width';

export const POLYGONSCAN_ADDRESS_URL = 'https://polygonscan.com/address/';